import React, { Component } from 'react';
import Finder from './components/Finder';
import Cart from './components/Cart';
import Navigation from './components/Navigation';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import MediaQuery from 'react-responsive';
import 'react-image-lightbox/style.css';

import './css/style.css';
import './css/mobile.css';
import './App.css';

class App extends Component {

    constructor(){
        super();

        const moment = extendMoment(originalMoment);
        const today = moment();

        this.state = {
            searchStarted:false,
            dateInterval: moment.range(today.clone(), today.clone().add(1, "days")),
            rooms: 0,
            persons: 1,
            reason: 0,
            code: '',
            breakfast: false,
            doublebed: false,
            kitchen: false,
            placeforkids: false,
            petsallowed: false,
            showRoomMode: false,
            showCartMode: false,
            cart:[],
            client: {
                FirstName: '',
                LastName: '',
                Email: '',
                Code: '',
                Company: '',
                Phone: '',
                Zip: '',
                Country: '',
                Nationality: '',
                City: '',
                Address: '',
                Notes: ''
            }    
        }
        this.storeSearchParams = this.storeSearchParams.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.updateClient = this.updateClient.bind(this);
        this.setShowRoomMode = this.setShowRoomMode.bind(this);
        this.setShowCartMode = this.setShowCartMode.bind(this);
        this.handleBackToSearch = this.handleBackToSearch.bind(this);
        
    }

    addToCart(cartItem){
        this.setState(prevState => ({
            cart: [...prevState.cart, cartItem]
        }));
    }

    updateCart(cart){
        this.setState({cart:cart});
    }

    updateClient(client){
        this.setState({client:client});
    }

    setShowRoomMode(mode){
        this.setState({showRoomMode: mode});
    }

    setShowCartMode(){
        this.setState({showCartMode: true});
    }

    handleBackToSearch(){
        this.setState({showCartMode: false});
    }

    storeSearchParams(params){ 
        this.setState({
            searchStarted: true,
            dateInterval:params.dateInterval,
            rooms: params.rooms,
            persons: params.persons,
            reason: params.reason,
            code: params.code,
            breakfast: params.breakfast,
            doublebed: params.doublebed,
            kitchen: params.kitchen,
            placeforkids: params.placeforkids,
            petsallowed: params.petsallowed
        });
    }

    render() {
        
        if(this.state.showCartMode){
            return (
                <div>
                <MediaQuery query="(min-width: 600px)">
                    <div className="vb-main-container-2"> 
                        <Navigation cartItems={this.state.cart} 
                                    navlogo={true} 
                                    onShowCart={this.setShowCartMode}
                                    onUpdateCart={this.updateCart}
                        />
                        <Cart items={this.state.cart} 
                            promoCode={this.state.code}      
                            client={this.state.client}              
                            onBackToSearch={this.handleBackToSearch}
                            onUpdateCart={this.updateCart}  
                            onUpdateClient={this.updateClient}                        
                        />
                    </div>
                </MediaQuery>
                <MediaQuery query="(max-width: 599px)">
                    <div className="vbmobile-main-container">
                        <Navigation cartItems={this.state.cart} 
                                    navlogo={true} 
                                    onShowCart={this.setShowCartMode}
                                    onUpdateCart={this.updateCart}
                        />
                        <Cart items={this.state.cart} 
                            promoCode={this.state.code}      
                            client={this.state.client}              
                            onBackToSearch={this.handleBackToSearch}
                            onUpdateCart={this.updateCart}  
                            onUpdateClient={this.updateClient}                        
                        />
                    </div>
                </MediaQuery>
                </div>
                
            )
        }else{
            return (
                <div>
                    <MediaQuery query="(min-width: 600px)">
                        <div className={this.state.showRoomMode ? "vb-main-container-2" : "vb-main-container"}> 

                        <Finder searchStarted={this.state.searchStarted} 
                                cart={this.state.cart}
                                onSearchResult={this.storeSearchParams} 
                                onAddToCart={this.addToCart}
                                onShowRoom={this.setShowRoomMode}
                                onUpdateCart={this.updateCart}
                                onShowCart={this.setShowCartMode}
                                dateInterval={this.state.dateInterval}
                                rooms={this.state.rooms}
                                persons={this.state.persons}
                                reason={this.state.reason}
                                code={this.state.code}
                                breakfast={this.state.breakfast}
                                doublebed={this.state.doublebed}
                                kitchen={this.state.kitchen}
                                placeforkids={this.state.placeforkids}
                                petsallowed={this.state.petsallowed}
                        /> 

                        </div>
                    </MediaQuery>
                    <MediaQuery query="(max-width: 599px)">
                        <div className={this.state.searchStarted ? "vbmobile-main-container" : "vbmobile-main-container vbmobile-home"}>
                            <Navigation
                                cartItems={this.state.cart} 
                                onUpdateCart={this.updateCart}
                                onShowCart={this.setShowCartMode}
                            />

                            <Finder searchStarted={this.state.searchStarted} 
                                cart={this.state.cart}
                                onSearchResult={this.storeSearchParams} 
                                onAddToCart={this.addToCart}
                                onShowRoom={this.setShowRoomMode}
                                onUpdateCart={this.updateCart}
                                onShowCart={this.setShowCartMode}
                                dateInterval={this.state.dateInterval}
                                rooms={this.state.rooms}
                                persons={this.state.persons}
                                reason={this.state.reason}
                                code={this.state.code}
                                breakfast={this.state.breakfast}
                                doublebed={this.state.doublebed}
                                kitchen={this.state.kitchen}
                                placeforkids={this.state.placeforkids}
                                petsallowed={this.state.petsallowed}
                        />

                        </div>
                    </MediaQuery>
                </div>
            );
        }
    }
}

export default App;
